import { z } from 'zod'
import type { IntelReport } from '../model/contracts'

const intelReportKPISchema = z.object({
  totalComments: z.number(),
  harshActionRequired: z.number(),
  negative: z.number(),
  positive: z.number(),
  neutral: z.number(),
})

const intelActionItemSchema = z.object({
  id: z.string(),
  title: z.string(),
  body: z.string(),
  priority: z.enum(['high', 'med', 'low']),
})

const intelTopicClusterSchema = z.object({
  id: z.string(),
  label: z.string(),
  summary: z.string(),
  sentiment: z.string(),
  recommendation: z.string(),
  exampleQuotes: z.array(z.string()),
})

const intelCommentBreakdownSchema = z.object({
  harsh: z.number(),
  abusive: z.number(),
  constructive: z.number(),
  supportive: z.number(),
})

const intelReportSchema = z.object({
  id: z.string(),
  topicId: z.string(),
  topicName: z.string(),
  range: z.string(),
  model: z.string(),
  generatedAt: z.string(),
  kpi: intelReportKPISchema,
  brief: z.string(),
  actionItems: z.array(intelActionItemSchema),
  topicClusters: z.array(intelTopicClusterSchema),
  commentBreakdown: intelCommentBreakdownSchema,
})

export function parseIntelReport(data: unknown): IntelReport {
  const result = intelReportSchema.safeParse(data)
  if (!result.success) {
    console.error('IntelReport Validation Failed:', z.treeifyError(result.error))
    console.error('Raw Payload:', data)
    throw new Error('Invalid IntelReport contract')
  }
  return result.data
}
